import '../static/Quote.css';
import React__default, { memo } from "react";
import clsx from "clsx";
import Image from "next/image.js";
import { b as Button } from "./Button.hIh6dJaA.mjs";
import { c as Heading } from "./Heading.D9qZoTZe.mjs";
import { b as Paragraph } from "./Paragraph.DAcb0zW2.mjs";
import { a as Logo } from "./Logo.5_HKhQuM.mjs";
const quote = `_quote_23922fa`;
const quoteIcon = `_quoteIcon_36ebcb0`;
const footer = `_footer_940bf64`;
const withImage = `_withImage_637f3d8`;
const bordered = `_bordered_405d779`;
const imageWrap = `_imageWrap_d50fadd`;
const memberImage = `_memberImage_ff0c804`;
const author = `_author_43089aa`;
const solution = `_solution_3ba728c`;
const byline = `_byline_c2953d6`;
const styles = { quote, quoteIcon, footer, withImage, bordered, imageWrap, memberImage, author, solution, byline };
const QUOTE_SIZE = ["sm", "md", "lg"];
const QUOTE_VARIANT = ["member", "client"];
const IMAGE_SIZE = 64;
function getHeadingSize(size) {
  switch (size) {
    case "sm":
      return "xl";
    case "lg":
      return "3xl";
    default:
      return "2xl";
  }
}
const QuoteImage = ({
  image,
  variant
}) => {
  if (!image) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement("figure", { className: clsx(styles.bordered, styles.imageWrap) }, variant === "client" ? /* @__PURE__ */ React__default.createElement(Logo, { ...image, "data-testid": "quote-logo" }) : /* @__PURE__ */ React__default.createElement(
    Image,
    {
      "data-testid": "quote-image",
      className: styles.memberImage,
      src: image.url,
      alt: image.alternativeText || "",
      width: IMAGE_SIZE,
      height: IMAGE_SIZE
    }
  ));
};
const QuoteInner = ({
  quote: quote2,
  author: author2,
  byline: byline2,
  image,
  size = "sm",
  solution: solution2,
  variant = "member"
}) => {
  return /* @__PURE__ */ React__default.createElement(
    "blockquote",
    {
      className: clsx(styles.quote, {
        [styles.withImage]: !!image
      }),
      "data-testid": "quote"
    },
    /* @__PURE__ */ React__default.createElement("div", { "aria-hidden": "true", className: styles.quoteIcon }),
    /* @__PURE__ */ React__default.createElement(Heading, { size: getHeadingSize(size), as: "p" }, quote2),
    /* @__PURE__ */ React__default.createElement("footer", { className: styles.footer }, author2 ? /* @__PURE__ */ React__default.createElement(
      Paragraph,
      {
        as: "span",
        weight: "semibold",
        size: "sm",
        className: styles.author
      },
      author2
    ) : solution2 && /* @__PURE__ */ React__default.createElement(
      Button,
      {
        size: "sm",
        variant: "text",
        href: solution2.href,
        onClick: solution2.onClick,
        target: solution2.target,
        className: styles.solution,
        "data-testid": "quote-solution"
      },
      solution2.label,
      " member"
    ), /* @__PURE__ */ React__default.createElement(QuoteImage, { image, variant }), /* @__PURE__ */ React__default.createElement(
      Paragraph,
      {
        "data-testid": "quote-byline",
        as: "span",
        size: "sm",
        className: clsx(styles.bordered, styles.byline)
      },
      byline2
    ))
  );
};
const Quote = memo(QuoteInner);
export {
  QUOTE_SIZE as Q,
  QUOTE_VARIANT as a,
  Quote as b
};
//# sourceMappingURL=Quote.BPj0dqrC.mjs.map
